<div class="content-wrapper">
  <gd-sidebar-nav [hovered]="hovered" [minimise]="isMinimised" [navigationTree]="navigationTree"></gd-sidebar-nav>
</div>
